export default {"src":"/_next/static/media/9.b226f666.svg","height":37,"width":37,"blurWidth":0,"blurHeight":0};